import { renderBinaryRadioButtonGroup, } from './renderBinaryRadioButtonGroup.js';
export const renderPayout = (props) => renderBinaryRadioButtonGroup({
    ...props,
    items: [
        { id: 'everyMonth', text: 'Ежемесячно' },
        { id: 'atEndTerm', text: 'В конце срока' },
    ],
});
//# sourceMappingURL=renderPayout.js.map